import { format } from "date-fns";
import { enUS } from "date-fns/locale/en-US";

const DATE_PATTERN = "dd MMM yyyy";
const DATE_TIME_PATTERN = "dd MMM yyyy HH:mm";
const TIME_PATTERN = "HH:mm:ss";
const TIME_DATE_PATTERN = "HH:mm dd MMM yyyy";

export function formatDateEnglish(value: Date): string {
  return format(value, DATE_PATTERN, { locale: enUS });
}

export function formatDateTimeEnglish(value: Date): string {
  return format(value, DATE_TIME_PATTERN, { locale: enUS });
}

export function formatTimeEnglish(value: Date): string {
  return format(value, TIME_PATTERN, { locale: enUS });
}

export function formatTimeDateEnglish(value: Date): string {
  return format(value, TIME_DATE_PATTERN, { locale: enUS });
}

export function formatUnixDateEnglish(unixSeconds: number): string {
  return formatDateEnglish(new Date(unixSeconds * 1000));
}

export function formatUnixDateTimeEnglish(unixSeconds: number): string {
  return formatDateTimeEnglish(new Date(unixSeconds * 1000));
}

export function formatUnixTimeEnglish(unixSeconds: number): string {
  return formatTimeEnglish(new Date(unixSeconds * 1000));
}

export function formatUnixTimeDateEnglish(unixSeconds: number): string {
  return formatTimeDateEnglish(new Date(unixSeconds * 1000));
}
